import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-filter-bydate',
  templateUrl: './order-filter-bydate.component.html',
  styleUrls: ['./order-filter-bydate.component.scss']
})
export class OrderFilterBydateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
